import { axiosInstance as request } from '@api/rest.service'
export * from './license-periods'
export * from './license-term-labels'
export * from './license-qualifier-labels'

const api = '/licenses'

/**
 * @description GET /licenses
 * @returns {AxiosPromise<any>}
 */
export const GET_LICENSES = () => request.get(api)

/**
 * @description GET /licenses?paginated=true (+ag grid filter model)
 * @returns {AxiosPromise<any>}
 */
export const GET_PAGINATED_LICENSES = params => {
  return request.get('/licenses?paginated=true', { params })
}

/**
 * @description PUT /licenses/{id}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_LICENSE = (id, payload) => request.put(`${api}/${id}`, payload)

/**
 * @description GET /licenses/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_LICENSE = id => request.get(`${api}/${id}`)

/**
 * @description GET /licenses/{id}/delete-confirmation
 * @returns {AxiosPromise<any>}
 */
export const GET_LICENSE_DELETE_CONFIRMATION = id => request.get(`${api}/${id}/delete-confirmation`)

/**
 * @description DELETE /licenses/{id}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_LICENSE = id => request.delete(`${api}/${id}`)
